import Cookies from 'js-cookie'
import { getUrlForCurrentEnvironment } from '../../../../global/environments/config.js'
import {
  removeTimeoutBanner,
  showTimeoutBanner,
} from '../../../../components//AlertBanner/index.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { keepSSOSessionAlive } from '../../../../global/authentication/authentication-manager.js'
import { dataStorage } from './institutionalConstants.js'

export const getClientId = () => {
  const dev = null
  const qa = window.WAM_INST_CLIENT_ID
  const prod = window.WAM_INST_CLIENT_ID

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

/**
 * LOL, lets see if veracode catches this
 */
export const getClientSecret = () => {
  const dev = null
  const qa = window.WAM_INST_CLIENT_SECRET
  const prod = window.WAM_INST_CLIENT_SECRET

  return getUrlForCurrentEnvironment(qa, dev, qa, prod)
}

export const storage = {
  get(key) {
    return JSON?.parse(window?.localStorage.getItem(key)) ?? null
  },
  set(key, val) {
    const stringify = JSON?.stringify(val) ?? null
    return window?.localStorage.setItem(key, stringify)
  },
  del(key) {
    window?.localStorage.removeItem(key)
  },
}

export const accessStorage = {
  getToken() {
    return storage.get(dataStorage.apiToken)
  },
  setToken(value) {
    storage.set(dataStorage.apiToken, value)
  },
  getTracingIds() {
    return storage.get(dataStorage.tracingId)
  },
  setTracingIds(value) {
    const getIds = this.getTracingIds()
    storage.set(dataStorage.tracingId, { ...getIds, ...value })
  },
  getUserInfo() {
    return storage.get(dataStorage.userInfo)
  },
  setUserInfo(value) {
    const getIds = this.getUserInfo()
    storage.set(dataStorage.userInfo, { ...getIds, ...value })
  },
  getUserId() {
    return storage.get(dataStorage.userId)
  },
  setUserId(value) {
    storage.set(dataStorage.userId, value)
  },
  getInstitutionalLoggedIn() {
    return storage.get(dataStorage.loggedIn)
  },
  setInstitutionalLoggedIn() {
    storage.set(dataStorage.loggedIn, 'LOGGEDIN')
  },
  getUserAgreement() {
    return storage.get(dataStorage.userAgreement)
  },
  setUserAgreement(value) {
    storage.set(dataStorage.userAgreement, value)
  },
  getRMInfo() {
    return storage.get(dataStorage.RMInfo)
  },
  setRMInfo(value) {
    storage.set(dataStorage.RMInfo, value)
  },
}

export const isInstitutionalLoggedIn = () =>
  accessStorage?.getInstitutionalLoggedIn() === 'LOGGEDIN'

export const logoutInstitutional = () => {
  storage.del(dataStorage.loggedIn)
  storage.del(dataStorage.apiToken)
  storage.del(dataStorage.tracingId)
  storage.del(dataStorage.userInfo)
  storage.del(dataStorage.RMInfo)
  Cookies.remove('SMSESSION')
  Cookies.set('CSMSESSION', 'LOGGEDOFF', { secure: true })
}

const clearLoginSession = () => {
  if (window?.location?.search) {
    const urlParams = new URLSearchParams(window.location.search)
    const CSMSESSION = urlParams?.get('CSMSESSION')
    const timeout = urlParams?.get('timeout')
    if (CSMSESSION === 'NO' || timeout === 'true') {
      logoutInstitutional()
    }
  }
}

window.CTI_TIMER_IN_MINUTES_BEFORE_SHOW_BANNER = 9
window.CTI_TIMER_IN_MINUTES_TO_SHOW_COUNTDOWN_IN_BANNER = 5
let bannerTimeoutTimer = 0

// keep track of current date, the last guy to update
// this variable is the only one that matters in context of timing out
let currentSessionDate = null

export function initInstSession() {
  if (isInstitutionalLoggedIn()) {
    resetTimeout()
  }
  clearLoginSession()
  // to make debugging easier
  window.CTI_INST_resetTimeout = resetTimeout
}

const closedClicked = () => {
  removeTimeoutBanner()
  keepSSOSessionAlive()
  resetTimeout()
}

const resetTimeout = function () {
  clearTimeout(bannerTimeoutTimer)
  currentSessionDate = new Date()
  window.localStorage.setItem('instSessionTimeoutTime', currentSessionDate)
  bannerTimeoutTimer = setTimeout(handleTimeout, getTimeoutTimeToShowBanner())
}

const handleTimeout = () => {
  if (
    new Date(window.localStorage.getItem('instSessionTimeoutTime')) <=
    currentSessionDate
  ) {
    showTimeoutBanner(
      window.CTI_TIMER_IN_MINUTES_TO_SHOW_COUNTDOWN_IN_BANNER,
      closedClicked,
      onTimeComplete
    )
  }
}

const onTimeComplete = () => {
  logoutInstitutional()
  window.location.href = getRelativeBasePath() + '/login?timeout=true'
}

const getTimeoutTimeToShowBanner = function () {
  return window.CTI_TIMER_IN_MINUTES_BEFORE_SHOW_BANNER * 1000 * 60
}

export const formatNewDate = (epochSeconds) => {
  const date = new Date(epochSeconds * 1000) // convert seconds to ms
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', // DST-aware: EST or EDT
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short', // "EST" or "EDT"
  })

  const parts = Object.fromEntries(
    fmt.formatToParts(date).map((p) => [p.type, p.value])
  )
  return `${parts.month} ${parts.day}, ${parts.year} at ${parts.hour}:${parts.minute} ${parts.dayPeriod} ${parts.timeZoneName}`
}
